// eslint-disable-next-line no-restricted-imports
import { passwordStrength as passwordStrengthOriginal } from 'check-password-strength';
import { PasswordStrengthOptions } from 'balus-common';
// eslint-disable-next-line no-restricted-imports
export type { DiversityType } from 'check-password-strength';

export const passwordStrength = (password: string) => {
  return passwordStrengthOriginal(password, PasswordStrengthOptions);
};
